<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *FORMULARIO GUARDAR ROL  -->
  <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">

        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('minutosDeGracia') | formControl" [id]="'minutosDeGracia'"
                          [label]="'Ingrese Minutos de Gracia*'"
                          [mostrarImg]="false" [placeholder]="'Minutos de gracia'" [rutaImagen]="" [type]="'number'"
                          formControlName="minutosDeGracia">
          </app-lfsa-input>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="formulario.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formulario>
    </form>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style" [pagination]="true"
                           [rowData]="rowData" [rowSelection]="rowSelection"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
